'use strict';

angular.module('clientDashboardApp').directive('windowResize', function ($window,$timeout) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs, ngModelCtrl) {

        var w = angular.element($window);

        w.bind('resize', function () {
          $timeout.cancel(scope.resizeTO);

          scope.resizeTO = $timeout(function() {
            w.triggerHandler('resizeEnd');
          }, 100);
        });

        w.bind('resizeEnd',function(){
          $timeout.cancel(scope.resizeTO);
        });

    }
  };
});
